import { db } from "../../../../config/firebase.config";
import create from "zustand";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
// @firebase/firestore
import {
  collection,
  onSnapshot,
  getDocs,
  query,
  where,
} from "firebase/firestore";

export const useStore = create((set) => ({
  fetchedProducts: false,
  products: [],
  productsFromCollection: [],
  collectionFilterTags: [],
  filteredColors: [],
  uniqueColorNames: [],
  wheelSizeFiltered: [],
  sizesFiltered: [],
  allProducts: [],
  //   const tags = products.map((prod) => {
  //     return {
  //       ...prod.tags,
  //     };
  //   });
  //   const options = products.map((prod) => {
  //     return {
  //       ...prod.options,
  //     };
  //   });
  //   const combinedTags = [];
  //   let combinedOptions = [];

  //   tags.map((tag) => {
  //     Object.values(tag).map((tag_value) => {
  //       combinedTags.push(tag_value);
  //     });
  //   });

  //   options.map((option) => {
  //     Object.values(option).map((option_value) => {
  //       if (option_value.name === "Available Sizes") {
  //         const currentValues = option_value.values;
  //         currentValues.map((size) => {
  //           combinedOptions.push(size);
  //         });
  //       }
  //     });
  //   });

  //   const uniqueSizes = [...new Set(combinedOptions)];

  //   const uniqueTags = [...new Set(combinedTags)];
  //   // console.log("uniqueTags", uniqueTags);

  //   const colorTagsFiltered = uniqueTags.filter((tag) =>
  //     tag.includes("colour")
  //   );
  //   const wheelSizeFiltered = uniqueTags.filter((tag) =>
  //     tag.includes("wheel_size")
  //   );

  //   const tempt = [];
  //   colorTagsFiltered.map((color) => {
  //     if (color.includes("name")) {
  //       const findColor = color.split(":")[1];
  //       tempt.push(findColor);
  //     }
  //   });

  //   const uniqueColors = [...new Set(tempt)];

  //   set({
  //     collectionFilterTags: uniqueTags,
  //     filteredColors: colorTagsFiltered,
  //     wheelSizeFiltered: wheelSizeFiltered,
  //     sizesFiltered: uniqueSizes,
  //     uniqueColorNames: uniqueColors,
  //   });
  // },
  getAllProducts: () => {
    try {
      let arr = [];
      const productsCollectionsRef = collection(db, "products");
      onSnapshot(productsCollectionsRef, (snapshot) => {
        snapshot.docs.map((doc) => {
          if (doc.data().status == "active") {
            var item = {
              ...doc.data(),
              id: doc.id,
            };
            arr.push(item);
          }
        });
        set({ products: arr });
        set({ fetchedProducts: true });
      });
      return arr;
    } catch (error) {
      toast("Error fetching the products", {
        ...config,
        type: "error",
      });
    }
  },
  getProductsFromSingleCollection: async (payload) => {
    try {
      let arr = [];
      const q = query(
        collection(db, "products"),
        where("collections", "array-contains", payload)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        if (doc.data().status == "active") {
          arr.push(doc.data());
        }
      });
      set({ products: arr });
      return arr;
    } catch (error) {
      toast("Error fetching the products", {
        ...config,
        type: "error",
      });
    }
  },
  searchProducts: (payload) => {
    const productType = payload.products.filter((product) => {
      return product.productType.toLocaleLowerCase().includes(payload.term);
    });
    const productTitle = payload.products.filter((product) => {
      return product.title.toLocaleLowerCase().includes(payload.term);
    });
    // https://stackoverflow.com/questions/21987909/how-to-get-the-difference-between-two-arrays-of-objects-in-javascript
    const uniqueResult = productType.filter((obj) => {
      return !productTitle.some((obj2) => {
        return obj.title == obj2.title;
      });
    });
    const result = productTitle.concat(uniqueResult);
    return result;
  },
  formattedProducts: (payload) => {
    let arr = [];
    let imageArr = [];

    payload.map((product) => {
      product.images.map((image) => {
        imageArr.push({
          transformedSrc: image.src,
        });
      });
      arr.push({
        description: product.body_html,
        handle: product.handle,
        images: {
          nodes: imageArr,
        },
        options: product.options,
        priceRange: {
          maxVariantPrice: {
            amount: product.variants[0].price,
          },
        },
        productType: product.product_type,
        tags: product.tags,
        title: product.title,
      });
      imageArr = [];
    });
    return arr;
  },
  sortProductsByHandle: (a, b) => {
    if (a.handle < b.handle) {
      return -1;
    }
    if (a.handle > b.handle) {
      return 1;
    }
    return 0;
  },

  getProductsFromSingleCollection: async (payload) => {
    try {
      let arr = [];
      const q = query(
        collection(db, "products"),
        where("collections", "array-contains", payload)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        if (doc.data().status == "active") {
          arr.push(doc.data());
        }
      });
      set({ productsFromCollection: arr });
      set({ fetchedProducts: true });
      return arr;
    } catch (error) {
      toast("Error fetching the products", {
        ...config,
        type: "error",
      });
    }
  },
  setAllProducts: (payload) => {
    set({ allProducts: payload });
  },
}));
